var _path, _style;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnimatedLine1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 328,
    viewBox: "0 0 1440 328",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {},
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1571 1C1478.15 96.0616 1216.36 187.383 933.268 218.83C902.115 222.291 870.748 218.262 840.465 210.173C603.741 146.944 140.071 108.193 -196 327.5",
    stroke: "#CACACA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "jpLlqTqu_0"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    "data-made-with": "vivus-instant"
  }, ".jpLlqTqu_0{stroke-dasharray:1849 1851;stroke-dashoffset:1850;animation:jpLlqTqu_draw 2000ms ease-in-out 0ms forwards;}@keyframes jpLlqTqu_draw{100%{stroke-dashoffset:0;}}@keyframes jpLlqTqu_fade{0%{stroke-opacity:1;}94.44444444444444%{stroke-opacity:1;}100%{stroke-opacity:0;}}")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnimatedLine1);
export default __webpack_public_path__ + "static/media/animated_line_1.64a5c8d7d64beb5c8a43f3799ca30ed8.svg";
export { ForwardRef as ReactComponent };